module.exports = __webpack_public_path__ + "assets/img/decktasche-neu.69747efd.png";